(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-guide"] && !Shopify.designMode) return;
  try {
    /*
    The behaviour is deliberately thin: opening and closing are <dialog>'s job,
    and the panel's content is static and needs no re-rendering. What is left
    here is routing the clicks and playing the movement.
  */
  class SizeGuide extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.size-guide__dialog');
      this.panel = this.querySelector('.size-guide__panel');
      this.overlay = this.querySelector('.size-guide__overlay');

      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onPanelClick = this.onPanelClick.bind(this);
      this.onCancel = this.onCancel.bind(this);

      /*
        Delegated from the document rather than a handler on the button: there
        are two triggers, and the one in the mobile bar is re-rendered when the
        variant changes — a listener attached to the button itself would not
        survive that.
      */
      document.addEventListener('click', this.onDocumentClick);
      this.addEventListener('click', this.onPanelClick);

      // Esc closes the dialog instantly; this routes it through the same animation.
      this.dialog.addEventListener('cancel', this.onCancel);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
    }

    onDocumentClick(event) {
      const trigger = event.target.closest('[data-size-guide-open]');
      if (!trigger) return;

      /*
        An empty value on the trigger means "there is one panel on this page" —
        which is how both of the product page's triggers work. A non-empty one
        has to match the panel's identifier: the bundle page carries as many
        panels as there are components, and without the check they would all
        open at once.
      */
      const wanted = trigger.getAttribute('data-size-guide-open');
      if (wanted && wanted !== (this.getAttribute('data-size-guide-id') || '')) return;

      event.preventDefault();
      this.open();
    }

    onPanelClick(event) {
      if (event.target.closest('[data-size-guide-close]')) this.close();
    }

    onCancel(event) {
      event.preventDefault();
      this.close();
    }

    /*
      The movement is played through the Web Animations API rather than
      described in CSS, a conclusion carried over from the cart after three
      attempts:

      1. [open] + @starting-style + `transition: display allow-discrete`:
         the first opening arrived instantly. The dialog enters the top layer
         and gets its final style in one frame, with nothing to interpolate
         from.
      2. A class toggled two frames later: it worked exactly as long as the
         attribute and the dialog's own state agreed. Any close that bypassed
         close() left the attribute behind, and the next opening started already
         open — "works every other time".

      An explicit animation has neither problem: the first frame is the initial
      state, and the state lives in the animation object rather than in an
      attribute.
    */
    open() {
      // Read before showModal(): a closed dialog has no rendered panel.
      const from = this.dialog.open ? this.currentOffset() : '100%';

      if (!this.dialog.open) this.dialog.showModal();

      /*
        preventScroll matters: at that moment the panel is still off screen, and
        an ordinary focus() makes the browser scroll it into view — which is
        exactly the sideways jerk mid-entrance.
      */
      const close = this.querySelector('.size-guide__close');
      if (close) close.focus({ preventScroll: true });

      this.play(
        [{ transform: `translateX(${from})` }, { transform: 'translateX(0px)' }],
        [{ opacity: this.currentOpacity() }, { opacity: 0.3 }],
        { duration: 300, easing: 'cubic-bezier(0.32, 0.72, 0, 1)' }
      );
    }

    close() {
      if (!this.dialog.open) return;

      const finished = this.play(
        [{ transform: `translateX(${this.currentOffset()})` }, { transform: 'translateX(100%)' }],
        [{ opacity: this.currentOpacity() }, { opacity: 0 }],
        { duration: 240, easing: 'cubic-bezier(0.4, 0, 1, 1)', fill: 'forwards' }
      );

      // A cancelled animation rejects; that only happens when an opening has
      // taken over.
      finished.then(() => this.dialog.close()).catch(() => {});
    }

    /*
      Where the panel is right now, so that one closed halfway and reopened
      travels from there rather than jumping to the edge.

      Read from the matrix rather than the translate property: every engine has
      animated transform for a decade, while support for a standalone translate
      in the Web Animations API cannot be guaranteed in WebKit. The matrix is
      also always in pixels.
    */
    currentOffset() {
      const transform = getComputedStyle(this.panel).transform;
      if (!transform || transform === 'none') return '0px';

      try {
        return `${new DOMMatrixReadOnly(transform).m41}px`;
      } catch {
        return '0px';
      }
    }

    currentOpacity() {
      return Number(getComputedStyle(this.overlay).opacity);
    }

    play(panelFrames, overlayFrames, options) {
      if (this.panelAnimation) this.panelAnimation.cancel();
      if (this.overlayAnimation) this.overlayAnimation.cancel();

      // Reduced motion: no slide, but the dialog still has to open and close.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return Promise.resolve();
      }

      this.panelAnimation = this.panel.animate(panelFrames, options);
      this.overlayAnimation = this.overlay.animate(overlayFrames, options);

      return this.panelAnimation.finished;
    }
  }

  if (!customElements.get('size-guide')) {
    customElements.define('size-guide', SizeGuide);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-select"] && !Shopify.designMode) return;
  try {
    /*
    The component owns only the opening and the painting of its own trigger.
    Which variant is chosen and what to do about it is the section's business:
    `change` from a radio bubbles out carrying data-option-index and value.
  */
  class VariantSelect extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('[data-select]');
      this.trigger = this.querySelector('summary');
      if (!this.details || !this.trigger) return;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.onChange = this.onChange.bind(this);
      this.onTriggerClick = this.onTriggerClick.bind(this);
      this.onToggle = this.onToggle.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onOutsidePointer = this.onOutsidePointer.bind(this);
      this.onOtherOpened = this.onOtherOpened.bind(this);

      this.addEventListener('change', this.onChange);
      this.addEventListener('keydown', this.onKeyDown);
      this.trigger.addEventListener('click', this.onTriggerClick);
      this.details.addEventListener('toggle', this.onToggle);

      /*
        pointerdown rather than click: on click the panel does not close until
        after the press has already reached the element underneath.
      */
      document.addEventListener('pointerdown', this.onOutsidePointer);
      /*
        Neighbouring lists open upward out of neighbouring columns and would
        overlap. The message goes through the document rather than a shared
        registry: that way it works between sections too, without introducing
        them to each other.
      */
      document.addEventListener('variant-select:open', this.onOtherOpened);

      this.syncTrigger();
    }

    disconnectedCallback() {
      document.removeEventListener('pointerdown', this.onOutsidePointer);
      document.removeEventListener('variant-select:open', this.onOtherOpened);
      clearTimeout(this.closeTimer);
    }

    onChange() {
      this.syncTrigger();

      /*
        The choice is made and the panel has nothing left to show; focus goes
        back to the trigger, or it would be left on a radio that no longer exists
        and would fall to the top of the document.
      */
      this.setOpen(false);
      this.trigger.focus();
    }

    /*
      The source of truth is the checked radio rather than the trigger's
      markup, so the label and the swatch in <summary> are rewritten from it.
      The swatch is found by data-swatch, which only the trigger has: the rows
      get their colour from an inline --swatch.
    */
    syncTrigger() {
      const checked = this.querySelector('input:checked');
      if (!checked) return;

      const label = this.querySelector('[data-trigger-label]');
      if (label) label.textContent = checked.value;

      const swatch = this.querySelector('[data-swatch]');
      if (swatch) swatch.style.setProperty('--swatch', checked.dataset.swatchColor || 'transparent');
    }

    /*
      A browser does not render the contents of a closed <details>, so removing
      open means snatching the panel away. The attribute lets the transition
      finish and only then closes the element. A timer rather than transitionend:
      the event never arrives if transitions are switched off by styles or the
      panel is already hidden, and the panel would be left hanging open. The 180
      has to match the styles.
    */
    setOpen(open) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
      this.details.removeAttribute('data-closing');

      if (open) {
        this.measureRoom();
        this.details.open = true;
        return;
      }

      if (!this.details.open) return;

      if (this.reducedMotion.matches) {
        this.details.open = false;
        return;
      }

      this.details.setAttribute('data-closing', '');
      this.closeTimer = setTimeout(() => {
        this.details.removeAttribute('data-closing');
        this.details.open = false;
      }, 180);
    }

    /*
      The panel opens upward, and there is sometimes less room above the
      trigger than the 20rem it is given — on a phone in landscape that already
      shows. The distance from the top of the screen to the host cannot be
      expressed in CSS, so the script measures it. A floor of one row: on a
      really short screen let there be something scrollable left rather than a
      strip collapsed to nothing.
    */
    measureRoom() {
      const room = this.details.getBoundingClientRect().top - 8;
      this.details.style.setProperty('--panel-max', `${Math.max(room, 44)}px`);
    }

    /*
      Closing from the trigger is the one path that bypasses setOpen: the
      browser removes open itself. Opening, by contrast, is entirely native, and
      this is its only point of interception — measuring before the panel
      appears. One click handler catches the mouse, Enter and Space alike:
      <summary> produces a click for all three.
    */
    onTriggerClick(event) {
      if (!this.details.open) {
        this.measureRoom();
        return;
      }

      event.preventDefault();
      this.setOpen(false);
    }

    onToggle() {
      if (!this.details.open) return;
      document.dispatchEvent(new CustomEvent('variant-select:open', { detail: { source: this } }));
    }

    onOtherOpened(event) {
      if (event.detail.source === this) return;
      this.setOpen(false);
    }

    onKeyDown(event) {
      if (event.key !== 'Escape' || !this.details.open) return;

      // Otherwise the same Esc travels on and closes the cart along with it.
      event.stopPropagation();
      this.setOpen(false);
      this.trigger.focus();
    }

    onOutsidePointer(event) {
      if (!this.details.open || this.contains(event.target)) return;
      this.setOpen(false);
    }
  }

  if (!customElements.get('variant-select')) {
    customElements.define('variant-select', VariantSelect);
  }
  } catch(e) { console.error(e); }
})();

})();
